import { ServiceStore, RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";
import MMDailyReportStore from "stores/millermize/MMDailyReportStore";
// import HomeIcon from '@mui/icons-material/Home';

const dashboardRoute: RouteType[] = [
  {
    name: "Home",
    path: "/home",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Dashboard",
        enableRefreshButton: true,
        component: () => import("./Dashboard.Header"),
      },
      body: {
        component: () => import("./Dashboard.Body"),
        grayBackground: true, // Add if needed
      },
    },
    group: 'Administration',
  requiresAuth: false, // Inferring based on requiresPermission being false
    requiresPermission: false,
    onEnter: ({ rootStore }: { rootStore: RootStore }) => {
      const accountsStore = (rootStore as any)?.accountsStore as ServiceStore;
      if (accountsStore) {
        accountsStore.find();
      }

      // The dashboard's data is fetched HERE rather than in the cards, per the
      // routing rule — a card that loads its own data reloads it on every
      // re-render of the dashboard grid.
      //
      // Both calls are fire-and-forget and self-guarding: the cards render
      // their own empty states, so a slow or missing response leaves the
      // landing page usable rather than blocking it. Casts follow the
      // established MM route-hook pattern (see DailyReport.Route.ts) — MM
      // stores are registered dynamically, so RootStore types them loosely.
      const dailyReportStore = (rootStore as any)
        ?.mmDailyReportStore as MMDailyReportStore | undefined;
      dailyReportStore?.ensureLoaded();

      // Projects (the pipeline card) need no call here: MMProjectStore already
      // loads itself on sign-in via `when`, like every MM store except the
      // daily report one. Calling loadData here as well fired a second request
      // — and fired it BEFORE sign-in on a cold landing, where it could only
      // fail. The card renders zeros for the moment before the store resolves,
      // which MobX then fills in.
    },
    // The Accounts List dialog is retained: the summary card that opened it is
    // gone from the dashboard, but the dialog is registered by name and
    // removing a route's dialog is a wider change than this item asked for.
    dialogs: [
      {
        name: "AccountsListDialog",
        component: () => import("./Home.Body.AccountsSummaryList"),
        title: "Accounts List",
        cancelButton: true,
        height: 600,
      },
    ],
  },
];

export default dashboardRoute;
